const { BASE_URL } = require("../client");


const UPDATE_MAINSIDE_KITPAGE = BASE_URL + "/Kitpage/Main_side/";
const GET_MAINSIDE_KITPAGE= BASE_URL + "/Kitpage/Main_side/";

export {
    UPDATE_MAINSIDE_KITPAGE,
    GET_MAINSIDE_KITPAGE
}